const mEditionBillingMyPaymentsModalPendingChangePlan = {
  mEditionBillingMyPaymentsModalPendingChangePlan: {
    header: {
      changePaymentMethod: 'SOLICITUD DE CAMBIO DE MEDIO DE PAGO',
      changePaymentFrequency: 'SOLICITUD DE CAMBIO DE FRECUENCIA DE PAGO',
      changePlan: 'SOLICITUD DE CAMBIO DE PLAN'
    },

    section: {
      product: {
        academy: 'Profesional Universidad',

        admins: 'Administradores',

        affiliations: 'Afiliaciones',

        assets: 'Proyectos',

        commissions: {
          line1: 'Comisiones',
          line2: 'Sin Comisiones'
        },

        evaluations: 'Evaluaciones',

        integrations: 'Integraciones',

        instructors: 'Instructores',

        liveClasses: 'Clases en vivo por Zoom',

        mails: 'Listas de e-mail',

        maps: 'Mapas de Aprendizaje',

        name: 'PLAN',

        not: 'No',

        products: 'Productos',

        teachers: 'Profesores',

        projects: 'Proyectos',

        salesData: 'Puntos de Venta',

        student: 'Alumnos',

        studentControl: 'Control de alumnos',

        studentImport: 'Importación de alumnos'
      },

      subscription: {
        changePlan: 'PLAN',

        compensa: {
          line1: 'Compensación de',
          line2: 'por cambio de plan',
          line3: 'por cambio de medio de pago'
        },

        cupon: {
          line1: 'Se aplicó descuento',
          line2: 'del'
        },

        free: 'Gratis',

        idExtern: 'ID de suscripción en',

        payFirst: 'El primer pago sería el',
        payNext: 'El próximo pago será el',

        plan: {
          line1: 'A pagar en',
          line2: 'de'
        },

        payMethod: 'Medio de pago',

        payTrial: {
          line1: 'Pago por periodo de prueba de',
          line2: 'con'
        },

        state: {
          line1: 'Suscripción',
          line2: 'desde'
        },

        trial: 'Periodo de prueba de',

        title: 'SUSCRIPCIÓN'
      },

      unlimited: 'Ilimitado',

      warningParagraph: 'Si la solicitud aún permanece pendiente ten en cuenta que la activación puede demorar hasta 72 horas.'
    }
  }
}

export default mEditionBillingMyPaymentsModalPendingChangePlan
